import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { EventEmitter } from '@angular/core';
// Import global data service
import { DataService, Loading } from 'src/app/Services/Data/data.service';
import { GoogleAnalyticsService } from 'src/app/Services/google-analytics.service';
import { APP_BASE_LINK } from 'src/environments/constants';

@Component({
  selector: 'app-send',
  templateUrl: './send.component.html',
  styleUrls: ['./send.component.css']
})
export class SendComponent implements OnInit {
  APP_BASE_LINK = APP_BASE_LINK;
  onDocumentSelected: EventEmitter<any>;
  roles: any = [];
  document_roles: any = [];
  document_name: string = '';
  document_id: string = '';
  cc: string[] = [];
  invite: any = { to: [], from: '', cc: [], subject: '', message: '' };
  using_document_group: boolean;
  using_normal_invite: boolean;
  self_signer_first_role: boolean = false;
  snToken: string = '';
  sender_email: string = '';

  // Loading
  loading: Loading;

  // error
  error_messages: any = [];

  // email message
  subject: string = '';
  body: string = '';

  // template setting
  template_setting: any;
  using_template_setting: boolean;

  // data
  data: any;
  document_group: any;
  salesforce: any;
  origin_view: string = '';

  // emails form record
  record_emails: any = [];

  // bulk invite
  bulk_invite: boolean = false;
  bulk_invite_type: string = '';
  email_field: string = 'Email';
  // document group
  number_of_roles_in_group: any;

  option: string = '';

  salesforce_session_data: any;

  signer_email: String;
  sending_type: string;

  analyticsData: any = {};

  constructor(
    private dataService: DataService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private GA: GoogleAnalyticsService
  ) {
    this.loading = dataService.getLoading();

    this.onDocumentSelected = new EventEmitter();
    this.sending_type = this.activatedRoute.snapshot.queryParamMap.get('sending_type');
  }
  isObject(target) {
    return typeof target === 'object' && target !== null;
  }
  loadDataServiceInfo() {
    this.data = this.dataService.getData();
    this.document_group = this.dataService.getDocumentGroup();
    this.salesforce = this.dataService.getSalesforceData();
    this.template_setting = this.dataService.getData().template_setting;
    this.using_template_setting = this.dataService.getData().using_template_setting;

    try {
      this.sender_email = JSON.parse(this.salesforce.context).user.email;
    } catch {}
  }
  setOriginView(view: string, page_view: string) {
    if (page_view == undefined) {
      this.dataService.setOriginView(view);
    } else {
      this.dataService.setOriginView(page_view);
    }
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  async getSNToken() {
    return (await this.getSession()).sn_token;
  }
  private async getSession() {
    return await this.dataService.apiGetCall('/api/session').toPromise();
  }
  private setSNToken(token) {
    this.snToken = token;
  }

  async ngOnInit() {
    this.setSNToken(this.getSNToken());
    this.dataService.loadSalesforceData();
    this.dataService.getSalesforceData();
    let valid_emails = true;
    this.using_template_setting = false;
    this.record_emails = this.dataService.getRecordEmails();
    this.salesforce_session_data = await this.dataService
      .apiGetCall('/api/salesforce_session_data')
      .toPromise();

    this.dataService.maintenanceCheck(this.salesforce_session_data);

    await this.setSNToken(await this.getSNToken());
    if (!this.dataService.valid_salesforce_session(this.salesforce_session_data)) {
      this.updateLoading(false, '');
      this.updateError(this.dataService.salesforce_session_error);
      return;
    }

    var view = this.salesforce_session_data.view;
    const page_view = this.dataService.getUrlParamater('view').toLowerCase();
    const cc_values = this.dataService.getUrlParamater('cc').toLowerCase();
    var client = this.dataService.getUrlParamater('client').toLowerCase();
    this.option = this.dataService.getUrlParamater('option').toLowerCase();

    if (cc_values) {
      const cc_array = decodeURIComponent(cc_values).split(',');
      for (let i = 0; i < cc_array.length; i++) {
        cc_array[i] = decodeURIComponent(cc_array[i]).replace(' ', '');
      }
      this.cc = cc_array;
    }
    this.setOriginView(view, page_view);

    this.origin_view = this.dataService.getOriginView();
    // console.log(this.origin_view);
    if (this.origin_view === 'bulk_invite') {
      this.bulk_invite = true;
      this.bulk_invite_type = this.capitalizeFirstLetter(
        this.dataService.getUrlParamater('bulk_invite_type')
      );
      this.email_field = this.dataService.getUrlParamater('bulk_email_field');
      if (this.email_field === '' || !this.email_field) {
        this.email_field = 'Email';
      } else {
        this.email_field = this.dataService.getUrlParamater('bulk_email_field');
      }
    } else {
      this.bulk_invite = false;
    }
    this.loadDataServiceInfo();
    var role: any;
    var index;
    this.using_document_group = this.dataService.usingDocumentGroup();
    this.using_normal_invite = !this.using_document_group;
    var data = this.dataService.getData();
    if (this.using_document_group) {
      var document_group_data = this.dataService.getDocumentGroupData().documents;

      const documentGroupTemplateId = this.dataService.getDocumentGroupTemplateId();
      let documentGroupTemplate;
      let documentGroupTemplateInviteSteps;

      if (documentGroupTemplateId) {
        this.updateLoading(true, 'Loading roles.');
        documentGroupTemplate = await this.getDocumentGroupTemplateById(documentGroupTemplateId);
        if (documentGroupTemplate) {
          documentGroupTemplateInviteSteps = documentGroupTemplate.routing_details.invite_steps;
        }
        this.updateLoading(false, '');
      }

      index = 0;

      if (this.using_template_setting) {
        if (this.template_setting.subject.split(' ').join('') === '') {
          this.subject = `${data.sn_email} Needs Your Signature`;
        } else if (this.template_setting.subject !== undefined || this.template_setting.subject !== null) {
          this.subject = this.template_setting.subject;
        } else {
          this.subject = `${data.sn_email} Needs Your Signature`;
        }
        if (this.template_setting.body.split(' ').join('') === '') {
          this.body = `${data.sn_email} invited you to sign document group ${this.document_group.document_group_name}`;
        } else if (this.template_setting.body != undefined || this.template_setting.body != null) {
          this.body = this.template_setting.body;
        } else {
          this.body = `${data.sn_email} invited you to sign document group ${this.document_group.document_group_name}`;
        }
        document_group_data = this.applyTemplateSettingToDocumentGroup(document_group_data);
      } else {
        this.subject = `${data.sn_email} Needs Your Signature`;
        this.body = `${data.sn_email} invited you to sign document group ${this.document_group.document_group_name}`;
      }

      let role_count = 0;
      for (let i = 0; i < document_group_data.length; i++) {
        var roles: any = [];
        for (let j = 0; j < document_group_data[i].roles.length; j++) {
          var e = document_group_data[i].roles[j].default_email;
          // console.log('default email:' + e);
          var using_default = true;
          if (this.option === 'edit_email' || e.length == 0) {
            using_default = false;
          }
          let order = 1;
          if (document_group_data[i].roles[j].order) {
            order = document_group_data[i].roles[j].order;
          }

          role = {
            order: order,
            index: index,
            name: document_group_data[i].roles[j].name,
            sn_role_id: document_group_data[i].roles[j].unique_id,
            email: document_group_data[i].roles[j].default_email,
            allow_reassign: document_group_data[i].roles[j].allow_reassign || false,
            readonly: using_default,
            password: document_group_data[i].roles[j].password || '',
            expiration:
              +document_group_data[i].roles[j].expiration ||
              +document_group_data[i].roles[j].expiration_days ||
              30,
            reminder: this.isObject(document_group_data[i].roles[j].reminder)
              ? document_group_data[i].roles[j].reminder
              : +document_group_data[i].roles[j].reminder || 0,
            document_id: document_group_data[i].id,
            authentication_type: 'password',
            isOrderReadonly: false,
            isReminderDisabled: document_group_data[i].roles[j].isReminderDisabled
          };

          if (documentGroupTemplateInviteSteps) {
            const origin_document_id = document_group_data[i].origin_document_id;

            for (let idxIStep = 0; idxIStep < documentGroupTemplateInviteSteps.length; ++idxIStep) {
              for (
                let actionIndex = 0;
                actionIndex < documentGroupTemplateInviteSteps[idxIStep].invite_actions.length;
                ++actionIndex
              ) {
                const DGT_inviteActions =
                  documentGroupTemplateInviteSteps[idxIStep].invite_actions[actionIndex];

                if (
                  origin_document_id === DGT_inviteActions.document_id &&
                  role.name === DGT_inviteActions.role_name
                ) {
                  if (!this.using_template_setting) {
                    role.order = documentGroupTemplateInviteSteps[idxIStep].order;

                    const dgtEmail = DGT_inviteActions.email || '';
                    role.email = dgtEmail.toLowerCase().indexOf('unassigned email') === -1 ? dgtEmail : '';
                  }

                  role.readonly = this.option === 'edit_email' || role.email.length !== 0;
                  role.isOrderReadonly = true;

                  break;
                }
              }
            }
          }

          if (role.email.length == 0) {
            valid_emails = false;
          } else if (this.origin_view === 'bulk_invite') {
            valid_emails = true;
          } else if (!this.validateEmail(role.email)) {
            valid_emails = false;
          }
          roles.push(role);
          index++;
          role_count++;
        }

        var document_role = {
          document_name: document_group_data[i].document_name,
          document_id: document_group_data[i].id,
          roles: roles
        };
        this.document_roles.push(document_role);
      }

      // unset Document Group Template Id after it was used for roles
      this.dataService.unsetDocumentGroupTemplateId();

      this.number_of_roles_in_group = new Array(role_count);
    } else {
      this.signer_email = decodeURIComponent(this.dataService.getUrlParamater('signer').toLowerCase());
      var client = this.dataService.getUrlParamater('client').toLowerCase();
      this.option = this.dataService.getUrlParamater('option').toLowerCase();
      var over_write_role_email_with_signer = false;
      if (client.length > 0 && this.option === 'edit_email' && this.signer_email.length > 0) {
        over_write_role_email_with_signer = true;
      }

      index = 0;
      this.document_name = this.dataService.getData().document_name;
      this.document_id = this.dataService.getData().document_id;

      this.updateLoading(true, 'Loading document.');
      // only after all manipulations with document, especially after document put with fields updates,
      // we should get routing details because of fields id changes after put operation (it's important to use correct field_id for payment request)
      const document = await this.dataService.get_document(this.document_id);
      this.dataService.setRoutingDetails(document);
      this.updateLoading(false, '');

      var routing_details: any = this.dataService.getRoutingDetails()[0];

      if (this.using_template_setting) {
        routing_details = this.applyTemplateSetting(routing_details);

        if (over_write_role_email_with_signer === true && routing_details.data[0].signing_order == 1) {
          routing_details.data[0].default_email = this.signer_email;
        }
        if (this.template_setting.subject.split(' ').join('') === '') {
          this.subject = `${data.sn_email} Needs Your Signature`;
        } else if (this.template_setting.subject !== undefined || this.template_setting.subject !== null) {
          this.subject = this.template_setting.subject;
        } else {
          this.subject = `${data.sn_email} Needs Your Signature`;
        }
        if (this.template_setting.body.split(' ').join('') === '') {
          this.body = `${data.sn_email} invited you to sign document group ${this.document_group.document_group_name}`;
        } else if (this.template_setting.body != undefined || this.template_setting.body != null) {
          this.body = this.template_setting.body;
        } else {
          this.body = `${data.sn_email} invited you to sign document group ${this.document_group.document_group_name}`;
        }
      } else {
        this.subject = data.sn_email + ' Needs Your Signature';
        this.body = data.sn_email + ' invited you to sign document ' + data.document_name;
      }
      // over writes role first role email if its signing order 1 with signer email its a client
      if (over_write_role_email_with_signer === true && routing_details.data[0].signing_order == 1) {
        routing_details.data[0].default_email = this.signer_email;
      }

      for (let i = 0; i < routing_details.data.length; i++) {
        var default_email = routing_details.data[i].default_email;
        var using_default = true;
        if (this.option === 'edit_email') {
          using_default = false;
        } else if (default_email.length == 0) {
          using_default = false;
        }
        role = {
          index: index,
          order: routing_details.data[i].signing_order,
          name: routing_details.data[i].name,
          role_id: routing_details.data[i].role_id,
          email: routing_details.data[i].default_email,
          reassign: routing_details.data[i].reassign || false,
          readonly: using_default,
          password: routing_details.data[i].password || '',
          expiration: +routing_details.data[i].expiration || +routing_details.data[i].expiration_days || 30,
          reminder: this.isObject(routing_details.data[i].reminder)
            ? routing_details.data[i].reminder
            : +routing_details.data[i].reminder || 0,
          authentication_type: 'password',
          isReminderDisabled: routing_details.data[i].isReminderDisabled
        };

        if (routing_details.data[i].payment_request) {
          role.payment_request = routing_details.data[i].payment_request;
        }

        if (routing_details.data[i].inviter_role == true && this.option !== 'edit_email') {
          role.email = data.sn_email;
          if (routing_details.data[i].signing_order == 1) {
            this.self_signer_first_role = true;
            role.readonly = true;
          }
        }
        if (role.email.length == 0) {
          valid_emails = false;
        } else if (this.origin_view === 'bulk_invite') {
          valid_emails = true;
        } else if (!this.validateEmail(role.email)) {
          valid_emails = false;
        }
        this.roles.push(role);
        index++;
      }

      this.addCCEmailsFromRoutingDetails(this.cc, routing_details);
    }

    // setting up auto send from template setting data
    if (this.using_template_setting) {
      if (this.template_setting.auto_send == true && valid_emails && this.option !== 'edit_email') {
        if (this.using_document_group) {
          this.send_document_group_invite();
        }
        if (this.origin_view === 'bulk_invite') {
          this.send_bulk_invite('');
        } else {
          this.send_invite('');
        }
      }
    }
    this.updateLoading(false, '');
  }

  addCCEmailsFromRoutingDetails(ccList: string[], routing_details: any) {
    if (ccList && routing_details) {
      if (Array.isArray(routing_details)) {
        routing_details.forEach((rd) => {
          ccList.push(...(rd.cc || []));
        });
      } else {
        ccList.push(...(routing_details.cc || []));
      }
    }
  }

  async getDocumentGroupTemplateById(document_group_template_id) {
    let documentGroupTemplate = null;

    try {
      documentGroupTemplate = await this.dataService
        .apiGetCall(
          '/api/get_document_group_template?document_group_template_id=' + document_group_template_id
        )

        .toPromise();
    } catch (error) {
      documentGroupTemplate = null;
      console.log(error);
    }

    return documentGroupTemplate;
  }

  validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  check_valid_ordering(roles): boolean {
    if (roles.length === 0 || roles.length === 1) {
      return true;
    }

    const set = new Set<number>();
    for (let i = 0; i < roles.length; i++) {
      set.add(Number(roles[i].order));
    }

    const array_role_set = Array.from(set).sort((a, b) => a - b);
    let prev = array_role_set[0];
    if (prev !== 1) {
      return false;
    }

    for (let i = 1; i < array_role_set.length; i++) {
      const curr = array_role_set[i];
      if (prev + 1 !== curr) {
        return false;
      }
      prev = curr;
    }

    return true;
  }

  applyTemplateSetting(routing_details) {
    if (this.template_setting != undefined) {
      var roles = this.template_setting.roles;
      var error = false;
      if (roles === '') {
        return routing_details;
      } else if (roles) {
        var valid_order = this.check_valid_ordering(roles);
        if (roles.length != routing_details.data.length) {
          valid_order = false;
          error = true;
        }
        if (valid_order == false) {
          error = true;
        }
        for (var i = 0; i < routing_details.data.length; i++) {
          for (var j = 0; j < roles.length; j++) {
            if (roles[j].name == routing_details.data[i].name) {
              routing_details.data[i].isReminderDisabled = this.isObject(roles[j].reminder);
              routing_details.data[i].default_email = roles[j].email;
              routing_details.data[i].reassign = roles[j].allow_forwarding === 'yes';
              routing_details.data[i].reminder = this.isObject(roles[j].reminder)
                ? roles[j].reminder
                : +roles[j].reminder || 0;
              routing_details.data[i].expiration = +roles[j].expiration || +roles[j].expiration_days || 30;
              routing_details.data[i].password = roles[j].password || '';

              if (valid_order == true) {
                routing_details.data[i].signing_order = roles[j].order;
              }
            }
          }
        }
      }
    }
    if (error == true) {
      this.updateError(
        'Template Setting has invalid role ordering. Invite is using the original template role orders instead.'
      );
    }
    return routing_details;
  }
  applyTemplateSettingToDocumentGroup(document_group_data) {
    //
    if (this.template_setting) {
      var roles = this.template_setting.roles;

      if (roles) {
        for (let k = 0; k < roles.length; k++) {
          for (let i = 0; i < document_group_data.length; i++) {
            for (let j = 0; j < document_group_data[i].roles.length; j++) {
              if (roles[k].name == document_group_data[i].roles[j].name) {
                document_group_data[i].roles[j].default_email = roles[k].email;
                document_group_data[i].roles[j].isReminderDisabled = this.isObject(roles[k].reminder);
                if (roles[k].order) {
                  document_group_data[i].roles[j].order = roles[k].order;
                } else {
                  document_group_data[i].roles[j].order = 1;
                }
                document_group_data[i].roles[j].allow_reassign = roles[k].allow_forwarding === 'yes';
                document_group_data[i].roles[j].reminder = this.isObject(roles[k].reminder)
                  ? roles[k].reminder
                  : +roles[k].reminder || 0;
                document_group_data[i].roles[j].expiration =
                  +roles[k].expiration || +roles[k].expiration_days || 30;
                document_group_data[i].roles[j].password = roles[k].password || '';
              }
            }
          }
        }
      }
    }
    return document_group_data;
  }
  removeFromCC(email) {
    for (let i = 0; i < this.cc.length; i++) {
      if (email == this.cc[i]) {
        this.cc.splice(i, 1);
      }
    }
  }

  addToCC(ccInput) {
    this.cc.push(ccInput.value.split(' ').join(''));
    ccInput.value = '';
  }

  updateLoading(state: boolean, msg: string) {
    this.loading.update(state, msg);
  }
  updateError(msg: string) {
    this.error_messages.push(msg);
  }
  clearErrors() {
    this.error_messages = [];
  }
  removeErrorMessage(error_message) {
    for (let i = 0; i < this.error_messages.length; i++) {
      if (error_message == this.error_messages[i]) {
        // delete this.error_messages[i];
        this.error_messages.splice(i, 1);
      }
    }
  }

  send_invite(ccInput) {
    try {
      if (this.cc.length == 0) {
        try {
          if (ccInput.value.length != 0) {
            this.addToCC(ccInput);
          }
        } catch {}
      }
    } catch {}
    this.clearErrors();
    this.updateLoading(true, 'Sending Invite');
    var data = this.dataService.getData();
    // set subject and body of data model
    this.dataService.setSubjectAndBody(this.subject, this.body);
    // set roles
    this.dataService.setRoles(this.roles);

    // generate invite object to send to signnow from node backend
    this.invite.to = [];
    this.invite.subject = this.subject;
    this.invite.message = this.body;
    this.invite.from = data.document_owner_email;

    this.invite.cc = this.cc;
    var error_found = false;
    var cc_error = false;
    var email_error = false;
    var exp_error = false;
    var rmd_error = false;
    var empty_subject = false;
    var empty_body = false;
    var dup_email_error = false;

    if (this.subject.split(' ').join('') == '') {
      empty_subject = true;
      error_found = true;
    }
    if (this.body.split(' ').join('') == '') {
      empty_body = true;
      error_found = true;
    }
    for (let i = 0; i < this.cc.length; i++) {
      if (!this.validateEmail(this.cc[i])) {
        error_found = true;
        cc_error = true;
      }
    }
    for (let i = 0; i < this.roles.length; i++) {
      // remove white spaces from emails
      this.roles[i].email = this.roles[i].email.split(' ').join('');
      if (!this.validateEmail(this.roles[i].email)) {
        email_error = true;
        error_found = true;
      }

      if (this.roles[i].expiration < 3 || this.roles[i].expiration > 180) {
        exp_error = true;
        error_found = true;
      }
      if (
        !this.isObject(this.roles[i].reminder) &&
        (this.roles[i].reminder < 0 ||
          this.roles[i].reminder > 180 ||
          this.roles[i].reminder > this.roles[i].expiration)
      ) {
        rmd_error = true;
        error_found = true;
      }

      for (let j = 0; j < this.roles.length; j++) {
        if (
          this.roles[i].order == this.roles[j].order &&
          this.roles[i].email == this.roles[j].email &&
          i != j
        ) {
          dup_email_error = true;
          error_found = true;
        }
      }
    }

    for (let i = 0; i < this.roles.length; i++) {
      if (this.roles[i].order == 1 && this.roles[i].email == data.document_owner_email) {
        this.self_signer_first_role = true;
      }
    }

    if (dup_email_error) {
      this.updateError(
        `The same email can't be used for multiple roles. Enter a unique email for each role.`
      );
    }
    if (rmd_error) {
      this.updateError(
        `Please use a valid reminder value. If you don’t want to use the reminder, enter 0 for the reminder value.`
      );
    }
    if (exp_error) {
      this.updateError(`Please use a valid expiration value.`);
    }
    if (email_error) {
      this.updateError(`Please enter a valid invite email address.`);
    }
    if (cc_error) {
      this.updateError(`Please enter a valid CC email address.`);
    }
    if (empty_subject) {
      this.updateError(`Please enter a valid subject. Subject can't be empty.`);
    }
    if (empty_body) {
      this.updateError(`Please enter a valid body. Body can't be empty.`);
    }

    if (error_found) {
      this.updateLoading(false, '');
      return;
    }

    for (let i = 0; i < this.roles.length; i++) {
      let to: any;

      to = {
        email: this.roles[i].email,
        role_id: this.roles[i].role_id,
        role: this.roles[i].name,
        order: this.roles[i].order,
        expiration_days: this.roles[i].expiration,
        reminder: this.roles[i].reminder,
        reassign: this.roles[i].reassign
      };

      if (this.roles[i].payment_request) {
        to.payment_request = this.roles[i].payment_request;
      }

      if (this.roles[0].password.length !== 0) {
        to.authentication_type = this.roles[i].authentication_type;
        to.password = this.roles[i].password;
      }

      this.invite.to.push(to);
    }

    const sf_data = this.dataService.getSalesforceData();

    // preparing data for analytics (invite)
    const is_used_annotations = !!this.dataService.getData().annotations.length;
    const databindingForAnalytics: any = this.dataService.getAnalyticsDatabindingInfo()[0] || {
      is_update: false,
      is_append: false
    };
    const analytics = this.getAnalyticsData(
      sf_data,
      this.roles.length,
      is_used_annotations,
      databindingForAnalytics
    );

    const invite_data: any = {
      aData: analytics,
      invite: this.invite,
      sf_user_id: sf_data.sf_user_id,
      sf_token: sf_data.sf_token,
      sf_refresh: sf_data.sf_refresh,
      sf_record_id: sf_data.record_id,
      sf_record_type: sf_data.record_type
    };

    // Sending the invite object and document id to node back end that will send the invite via signnows api
    this.dataService
      .apiPostCall(
        `/api/send_invite?document_id=${data.document_id}&document_name=${data.document_name}`,
        JSON.stringify(invite_data)
      )

      .subscribe(
        (result) => {
          this.updateLoading(false, '');
          this.dataService.setSelfSigner(this.self_signer_first_role);
          if (this.signer_email.length !== 0) {
            this.dataService.setSelfSignerClientEmail(this.signer_email);
          } else {
            this.dataService.setSelfSignerClientEmail(this.invite.from);
          }
          this.dataService.saveSentDocumentAsNotesAndAttachments();
          // console.log("sn token: " + result.sn_token);
          this.dataService.setSNToken(result.sn_token);

          this.GA.trackEvent('invite', this.sending_type, 'send_invite');
          this.router.navigate(['result']);
        },
        (error) => {
          this.updateLoading(false, '');
          this.updateError(error.error);
        }
      );
  }

  check_if_text_tag(email: string) {
    var regExp = /{(.*?)}/g;
    var text_tag;
    text_tag = regExp.exec(email);
    if (text_tag) {
      return true;
    } else {
      return false;
    }
  }

  send_bulk_invite(ccInput) {
    try {
      if (this.cc.length == 0) {
        try {
          if (ccInput.value.length != 0) {
            this.addToCC(ccInput);
          }
        } catch {}
      }
    } catch {}
    this.clearErrors();
    this.updateLoading(true, 'Sending Bulk Invite.');
    var data = this.dataService.getData();
    // set subject and body of data model
    this.dataService.setSubjectAndBody(this.subject, this.body);
    // set roles
    this.dataService.setRoles(this.roles);

    // generate invite object to send to signnow from node backend
    this.invite.to = [];
    this.invite.subject = this.subject;
    this.invite.message = this.body;
    this.invite.from = data.document_owner_email;

    this.invite.cc = this.cc;
    var error_found = false;
    var cc_error = false;
    var email_error = false;
    var exp_error = false;
    var rmd_error = false;
    var empty_subject = false;
    var empty_body = false;
    var dup_email_error = false;

    if (this.subject.split(' ').join('') == '') {
      empty_subject = true;
      error_found = true;
    }
    if (this.body.split(' ').join('') == '') {
      empty_body = true;
      error_found = true;
    }
    for (var i = 0; i < this.cc.length; i++) {
      if (!this.check_if_text_tag(this.cc[i])) {
        if (!this.validateEmail(this.cc[i])) {
          error_found = true;
          cc_error = true;
        }
      }
    }
    for (var i = 0; i < this.roles.length; i++) {
      //remove white spaces from emails
      this.roles[i].email = this.roles[i].email.split(' ').join('');
      if (!this.check_if_text_tag(this.roles[i].email)) {
        if (!this.validateEmail(this.roles[i].email)) {
          email_error = true;
          error_found = true;
        }
      }

      if (this.roles[i].expiration < 3 || this.roles[i].expiration > 180) {
        exp_error = true;
        error_found = true;
      }
      if (
        !this.isObject(this.roles[i].reminder) &&
        (this.roles[i].reminder < 0 ||
          this.roles[i].reminder > 180 ||
          this.roles[i].reminder > this.roles[i].expiration)
      ) {
        rmd_error = true;
        error_found = true;
      }

      for (var j = 0; j < this.roles.length; j++) {
        if (
          this.roles[i].order == this.roles[j].order &&
          this.roles[i].email == this.roles[j].email &&
          i != j
        ) {
          dup_email_error = true;
          error_found = true;
        }
      }
    }
    if (dup_email_error) {
      this.updateError(
        `The same email can't be used for multiple roles. Enter a unique email for each role.`
      );
    }
    if (rmd_error) {
      this.updateError(
        `Please use a valid reminder value. If you don’t want to use the reminder, enter 0 for the reminder value.`
      );
    }
    if (exp_error) {
      this.updateError(`Please use a valid expiration value.`);
    }
    if (email_error) {
      this.updateError(`Please enter a valid invite email address.`);
    }
    if (cc_error) {
      this.updateError(`Please enter a valid CC email address.`);
    }
    if (empty_subject) {
      this.updateError(`Please enter a valid subject. Subject can't be empty.`);
    }
    if (empty_body) {
      this.updateError(`Please enter a valid body. Body can't be empty.`);
    }

    if (error_found) {
      this.updateLoading(false, '');
      return;
    }

    for (let i = 0; i < this.roles.length; i++) {
      let to: any;
      to = {
        email: this.roles[i].email,
        role_id: this.roles[i].role_id,
        role: this.roles[i].name,
        order: this.roles[i].order,
        expiration_days: this.roles[i].expiration,
        reminder: this.roles[i].reminder,
        reassign: this.roles[i].reassign
      };

      if (this.roles[i].payment_request) {
        to.payment_request = this.roles[i].payment_request;
      }

      if (this.roles[0].password.length !== 0) {
        to.authentication_type = this.roles[i].authentication_type;
        to.password = this.roles[i].password;
      }

      this.invite.to.push(to);
    }
    /*
    for(var i = 0; i < this.roles.length; i++){
      if(this.roles[i].order == 1 && this.roles[i].email == data.document_owner_email){
        this.self_signer_first_role = true;
      }
    }*/

    var sf_data = this.dataService.getSalesforceData();
    var bulk_invite_type = this.capitalizeFirstLetter(this.dataService.getUrlParamater('bulk_invite_type'));
    this.email_field = this.dataService.getUrlParamater('bulk_email_field');
    if (this.email_field === '' || !this.email_field) {
      this.email_field = 'Email';
    } else {
      this.email_field = this.dataService.getUrlParamater('bulk_email_field');
    }

    // preparing data for analytic (bulk invite)
    const is_used_annotations = false; // todo on this moment we don't know about it and will update this param on backend side
    const databindingForAnalytics: any = this.dataService.getAnalyticsDatabindingInfo()[0] || {
      is_update: false,
      is_append: false
    };
    const analytics = this.getAnalyticsData(
      sf_data,
      this.roles.length,
      is_used_annotations,
      databindingForAnalytics
    );

    var invite_data: any = {
      aData: analytics,
      invite: this.invite,
      record_list: this.dataService.getRecordList(),
      sf_user_id: sf_data.sf_user_id,
      sf_org_id: sf_data.sf_org_id,
      sf_token: sf_data.sf_token,
      sf_refresh: sf_data.sf_refresh,
      sf_record_id: sf_data.record_id,
      sf_record_type: sf_data.record_type,
      instance_url: sf_data.instance_url,
      document_name: data.document_name,
      bulk_invite_type: bulk_invite_type
    };

    // Sending the invite object and document id to node back end that will send the invite via signnows api
    this.dataService
      .apiPostCall(
        '/api/bulk_invite?document_id=' + data.document_id + '&document_name=' + data.document_name,
        JSON.stringify(invite_data)
      )

      .subscribe(
        (result) => {
          console.log(result);
          this.updateLoading(false, '');
          this.dataService.setSelfSigner(this.self_signer_first_role);
          let link = ['result'];
          this.router.navigate(link);
        },
        (error) => {
          if (error.status === 504) {
            let link = ['result'];
            this.router.navigate(link).then(
              function () {},
              function () {}
            );
          } else {
            this.updateLoading(false, '');
            this.updateError(error.error);
          }
        }
      );
  }

  updateDocumentGroupRolesOrder(selectedOrder, role) {
    role.order = parseInt(selectedOrder.value);
  }

  send_document_group_invite() {
    this.clearErrors();
    this.updateLoading(true, 'Sending Document Group Invite.');
    var document_group_data = this.dataService.getDocumentGroup();
    var group_id = document_group_data.document_group_id;
    var group_name = document_group_data.document_group_name;
    // set subject and body of data model
    this.dataService.setSubjectAndBody(this.subject, this.body);
    var sf_data = this.dataService.getSalesforceData();
    var error_found = false;
    var email_error = false;
    var exp_error = false;
    var rmd_error = false;
    var dup_email_error = false;
    var order_error = false;

    for (let j = 0; j < this.document_roles.length; j++) {
      const roles = this.document_roles[j].roles;
      for (let i = 0; i < roles.length; i++) {
        if (!this.validateEmail(roles[i].email)) {
          email_error = true;
          error_found = true;
        }

        if (roles[i].expiration < 3 || roles[i].expiration > 180) {
          exp_error = true;
          error_found = true;
        }
        if (
          !this.isObject(roles[i].reminder) &&
          (roles[i].reminder < 0 || roles[i].reminder > 180 || roles[i].reminder > roles[i].expiration)
        ) {
          rmd_error = true;
          error_found = true;
        }
      }

      // // preparing data for analytics (document_group invite) - adding aData for each document, but we want one record for a group so this way unsuitable
      // const is_used_annotations = !!(this.dataService.getDocumentGroup().annotations[j].document_annotation.length);
      // const databindingForAnalytics: any = this.dataService.getAnalyticsDatabindingInfo()[j] || {is_update: false, is_append: false};
      // this.document_roles[j].aData = this.getAnalyticsData(sf_data, roles.length, is_used_annotations, databindingForAnalytics);
    }

    var order_set = new Set();
    for (var i = 0; i < this.document_roles.length; i++) {
      for (var j = 0; j < this.document_roles[i].roles.length; j++) {
        this.document_roles[i].roles[j].order = parseInt(this.document_roles[i].roles[j].order);
        order_set.add(this.document_roles[i].roles[j].order);
      }
    }

    const sorted_order_array = Array.from(order_set as Set<number>).sort((a, b) => a - b);
    for (let i = 1; i < sorted_order_array.length; i++) {
      if (sorted_order_array[i - 1] + 1 !== sorted_order_array[i]) {
        order_error = true;
        error_found = true;
        break;
      }
    }

    var order_array = [];
    var max_order = 1;
    for (var i = 0; i < this.document_roles.length; i++) {
      for (var j = 0; j < this.document_roles[i].roles.length; j++) {
        order_array.push(this.document_roles[i].roles[j].order);
        if (this.document_roles[i].roles[j].order > max_order) {
          max_order = this.document_roles[i].roles[j].order;
        }
      }
    }

    for (var i = 1; i < max_order; i++) {
      if (order_array.indexOf(i) == -1) {
        order_error = true;
        error_found = true;
        break;
      }
    }

    for (var i = 0; i < this.document_roles.length; i++) {
      var roles = this.document_roles[i].roles;
      for (var j = 0; j < roles.length; j++) {
        for (var k = 0; k < roles.length; k++) {
          if (roles[j].email == roles[k].email && j != k && roles[j].order == roles[k].order) {
            dup_email_error = true;
            error_found = true;
          }
        }
      }
    }

    var empty_subject = false;
    var empty_body = false;

    if (this.subject.split(' ').join('') == '') {
      empty_subject = true;
      error_found = true;
    }
    if (this.body.split(' ').join('') == '') {
      empty_body = true;
      error_found = true;
    }
    if (order_error) {
      this.updateError("Roles must be in sequential order. Make sure that there aren't any skipped steps.");
    }
    if (empty_subject) {
      this.updateError("Please enter a valid subject. Subject can't be empty.");
    }
    if (empty_body) {
      this.updateError("Please enter a valid body. Body can't be empty.");
    }

    if (dup_email_error) {
      this.updateError(
        "The same email can't be used for multiple roles. Enter a unique email for each role."
      );
    }

    if (rmd_error) {
      this.updateError(
        'Please use a valid reminder value! If you wish to not use reminders please enter 0 for the reminder value!'
      );
    }
    if (exp_error) {
      this.updateError('Please use a valid expiration value.');
    }
    if (email_error) {
      this.updateError('Please enter valid invite email!');
    }

    if (error_found) {
      this.updateLoading(false, '');
      return;
    }

    var number_of_steps = 1;
    for (var i = 0; i < this.document_roles.length; i++) {
      for (var j = 0; j < this.document_roles[i].roles.length; j++) {
        if (this.document_roles[i].roles[j].order > number_of_steps) {
          number_of_steps = this.document_roles[i].roles[j].order;
        }
      }
    }

    // preparing data for analytics (document_group invite)
    // const set_of_roles = new Set();
    let rolesLength = 0;
    let is_used_annotations = false;
    const databindingForAnalytics: any = { is_update: false, is_append: false };
    // this.document_roles.forEach(dRole => dRole.roles.forEach(inside_role => set_of_roles.add(inside_role.email.toLowerCase())));

    for (let idx = 0; idx < this.document_roles.length; idx++) {
      is_used_annotations =
        !!this.dataService.getDocumentGroup().annotations[idx]?.document_annotation.length ||
        is_used_annotations;
      const docDatabindingParams = this.dataService.getAnalyticsDatabindingInfo()[idx] || {
        is_update: false,
        is_append: false
      };
      databindingForAnalytics.is_update = docDatabindingParams.is_update || databindingForAnalytics.is_update; // if any of param from each document_in_group is true
      databindingForAnalytics.is_append = docDatabindingParams.is_append || databindingForAnalytics.is_append; // if any of param from each document_in_group is true

      // this.document_roles[idx].roles.forEach(inside_role => set_of_roles.add(inside_role.email.toLowerCase()));
      rolesLength += this.document_roles[idx].roles.length;
    }

    const analytics = this.getAnalyticsData(
      sf_data,
      rolesLength,
      is_used_annotations,
      databindingForAnalytics
    );

    const document_group_invite: any = {
      aData: analytics,
      invite_steps: [],
      document_roles: this.document_roles,
      sf_user_id: sf_data.sf_user_id,
      sf_token: sf_data.sf_token,
      sf_refresh: sf_data.sf_refresh,
      sf_record_id: sf_data.record_id,
      sf_record_type: sf_data.record_type
    };

    for (var i = 1; i <= number_of_steps; i++) {
      var invite_step = {
        order: i,
        invite_actions: [],
        invite_emails: []
      };
      document_group_invite.invite_steps.push(invite_step);
    }

    for (var i = 0; i < this.document_roles.length; i++) {
      for (var j = 0; j < this.document_roles[i].roles.length; j++) {
        var invite_email = {
          email: this.document_roles[i].roles[j].email,
          disabled: 0,
          subject: this.subject,
          message: this.body,
          expiration_days: this.document_roles[i].roles[j].expiration,
          reminder: this.document_roles[i].roles[j].reminder
        };
        var invite_action: any;
        if (this.document_roles[i].roles[j].password.length == 0) {
          invite_action = {
            email: this.document_roles[i].roles[j].email,
            role_name: this.document_roles[i].roles[j].name,
            action: 'sign',
            document_id: this.document_roles[i].document_id,
            allow_reassign: +this.document_roles[i].roles[j].allow_reassign
          };
        } else {
          invite_action = {
            email: this.document_roles[i].roles[j].email,
            role_name: this.document_roles[i].roles[j].name,
            action: 'sign',
            document_id: this.document_roles[i].document_id,
            allow_reassign: +this.document_roles[i].roles[j].allow_reassign,
            authentication: {
              type: 'password',
              value: this.document_roles[i].roles[j].password
            }
          };
        }
        var order = this.document_roles[i].roles[j].order;
        // if the order is smaller then 0 or its larger then the total number of steps set it back to the default order of 1
        if (order - 1 < 0 || order - 1 >= document_group_invite.invite_steps.length) {
          order = 1;
        }
        try {
          document_group_invite.invite_steps[order - 1].invite_actions.push(invite_action);
          document_group_invite.invite_steps[order - 1].invite_emails.push(invite_email);
        } catch {}
      }
    }

    // Sending the invite object and document id to node back end that will send the invite via signnows api
    this.dataService
      .apiPostCall(
        '/api/send_document_group_invite?group_id=' + group_id + '&group_name=' + group_name,
        JSON.stringify(document_group_invite)
      )

      .subscribe(
        () => {
          this.updateLoading(false, '');
          this.dataService.setSelfSigner(this.self_signer_first_role);
          this.dataService.saveSentDocumentGroupAsNotesAndAttachments(this.document_roles);
          this.router.navigate(['result']);
          // console.log("document group invite response: " + result);
        },
        (error) => {
          this.updateLoading(false, '');
          this.updateError(error.error);
        }
      );
  }

  public trackByIndex(index: number) {
    return index;
  }

  // preparing data for analytics (invite, document_group invite, bulk invite)
  getAnalyticsData(sf_data, rolesLength, is_used_annotations, databindingForAnalytics) {
    const data = this.dataService.getData();

    const is_any_preselected_document_id = !!(
      this.dataService.getUrlParamater('attachment_id') || this.dataService.getUrlParamater('template_id')
    );
    const analytics: any = {
      // doc_status_oids: array of strings, // set this param from backend side - get from doc_status document
      invite: {
        is_signing_link: false, // when we use the link we do not go to the sending page (current page)
        sending_type: this.sending_type,
        record_type: sf_data.record_type,
        has_preselected_document: is_any_preselected_document_id,
        has_document_flow: this.using_template_setting,
        document_flow_settings: null,
        annotation: {
          is_used: is_used_annotations
        },
        data_binding: {
          is_append: databindingForAnalytics.is_append,
          is_update: databindingForAnalytics.is_update
        },
        signers_count: rolesLength,
        is_self_signer: this.self_signer_first_role,
        sender: this.dataService.getSignNowOwnerEmail() || this.sender_email || data.document_owner_email
      }
    };

    if (this.using_template_setting) {
      analytics.invite.document_flow_settings = {
        has_roles: !!(this.template_setting.roles && this.template_setting.roles.length),
        has_message_subject: !!this.template_setting.subject,
        has_message_body: !!this.template_setting.body,
        has_document_name: !!this.template_setting.document_name,
        has_automatically_send: !!this.template_setting.auto_send,
        has_skip_to_end: !!this.template_setting.skip_to_email_invite,
        has_hide_advanced_settings: !!this.template_setting.is_hide_advanced_settings,
        has_import_fields: !!this.template_setting.template_id
      };
    }

    return analytics;
  }
}
